module.exports = __webpack_public_path__ + "media/images/theodor_herzl_award/logo-9f247d514c4a7fac4c0c64beda13e0c6.svg";